import { render, staticRenderFns } from "./rectificationSummary.vue?vue&type=template&id=c823bd4e&scoped=true&"
import script from "./rectificationSummary.vue?vue&type=script&lang=js&"
export * from "./rectificationSummary.vue?vue&type=script&lang=js&"
import style0 from "./rectificationSummary.vue?vue&type=style&index=0&id=c823bd4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c823bd4e",
  null
  
)

export default component.exports